module.exports = __webpack_public_path__ + "media/images/emblems/Malans_wappen-8f3dcdd429428044a963d6664e555d69.svg";